import React, { useEffect, useState } from 'react';
import './PageLoader.css';
import logo from '../../assets/logo.png';

const PageLoader = ({ isLoading = true }) => {
  const [isMounted, setIsMounted] = useState(false);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (isLoading) {
      // Show loader immediately when loading starts
      setIsMounted(true);
      // Make loader active immediately to prevent white flash
      setIsActive(true);
    } else {
      // Start fade out animation
      setIsActive(false);
      // Remove from DOM after animation completes
      const timer = setTimeout(() => {
        setIsMounted(false);
      }, 500); // Match this with CSS transition duration
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  if (!isMounted) return null;
  
  return (
    <div className={`page-loader ${isActive ? 'active' : ''}`}>
      <div className="loader-content">
        <div className="logo-container">
          <img 
            src={logo} 
            alt="UniTrade Logo" 
            className="logo-spinner"
          />
          <div className="spinner">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
          </div>
        </div>
        <div className="progress-bar">
          <div className="progress"></div>
        </div>
      </div>
    </div>
  );
};

export default PageLoader;
